import React, { PropTypes } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';
import { bindActionCreators } from 'redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import DocumentHeadContainer from '../DocumentHeadContainer';
import NotFound from '@bibliocommons/not-found';
import { currentLibrarySelector } from '../../selectors/LibrarySelector';
import { currentAccountSelector } from '../../selectors/AuthSelector';
import { getRecentlyReturnedWithBibs, getBorrowingHistoryData } from '../../selectors/RecentlyReturnedSelector';
import * as RecentlyReturnedActions from '../../actions/RecentlyReturnedActions';
import RecentlyReturnedPrintList from '../../components/borrowing/recentlyreturned/RecentlyReturnedPrintList';

class PrintRecentlyReturnedContainer extends BcReactComponent {
  static fetchInitialData(params, query, store) {
    const account = currentAccountSelector(store.getState());
    const accountId = account && account.get('id');

    return [
      store.dispatch(RecentlyReturnedActions.fetchReturnHistory({ ...params, ...query, accountId }))
    ];
  }

  render() {
    return (
      <div className="cp-print-list">
        <DocumentHeadContainer pageTitle={this.props.intl.formatMessage({ id: 'section_title_recently_returned' })} />
        { this.props.recentlyReturnedSupported ?
          <RecentlyReturnedPrintList {...this.props} /> :
          <NotFound /> }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  RecentlyReturnedActions: bindActionCreators(RecentlyReturnedActions, dispatch)
});

const mapStateToProps = (state, ownProps) => {
  const library = currentLibrarySelector(state);
  const recentlyReturnedSupported = library.get('recentlyReturned');
  const items = getRecentlyReturnedWithBibs(state, ownProps);
  const accountId = currentAccountSelector(state).get('id').toString();
  const borrowingHistoryData = getBorrowingHistoryData(state);
  const pagination = borrowingHistoryData.get('pagination', Immutable.Map());
  const isFetching = borrowingHistoryData.get('isFetching');

  return {
    items,
    pagination,
    isFetching,
    recentlyReturnedSupported,
    accountId
  };
};

PrintRecentlyReturnedContainer.propTypes = {
  intl: intlShape,
  items: ImmutablePropTypes.list,
  pagination: ImmutablePropTypes.map,
  isFetching: PropTypes.bool,
  accountId: PropTypes.number
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(PrintRecentlyReturnedContainer));



// WEBPACK FOOTER //
// ./app/containers/print/PrintRecentlyReturnedContainer.jsx